import React from 'react';
import useViewportVisibility from '../../hooks/useViewportVisibility';

const frames = import.meta.glob('../../public/steps/*.webp', {eager: true, query: '?url', import: 'default'});

const StepAnimation = ({step, label}) => {
    const {ref, visible, entered} = useViewportVisibility();
    return (
        <div ref={ref} className={`step-animation step-animation-${step}${visible ? ' is-visible' : ''}`} role="img" aria-label={label}>
            <div className="step-animation-scene">
                {entered && <img src={frames[`../../public/steps/${step}.webp`]} alt="" decoding="async" width="1280" height="840"/>}
                {entered && step === 'customize' && ['settings-color', 'settings-poster', 'settings-landscape', 'settings-interior'].map((frame, index) => (
                    <img key={frame} className={`step-animation-frame step-animation-frame-${index + 1}`} src={frames[`../../public/steps/${frame}.webp`]} alt="" decoding="async" width="1280" height="840"/>
                ))}
            </div>
        </div>
    );
};

export default StepAnimation;
